var _ellipse, _ellipse2, _path, _path2, _rect, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.6147,
    cy: 29.4838,
    rx: 1.66742,
    ry: 1.64516,
    fill: "url(#paint0_linear_11184_60508)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.1713,
    cy: 29.4838,
    rx: 1.66742,
    ry: 1.64516,
    fill: "url(#paint1_linear_11184_60508)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1562 13.4839C15.1562 12.9316 15.604 12.4839 16.1562 12.4839H37.5001C38.0524 12.4839 38.5001 12.9316 38.5001 13.4839V40C38.5001 40.5523 38.0524 41 37.5001 41H16.1563C15.604 41 15.1562 40.5523 15.1562 40V13.4839Z",
    fill: "#4C4AEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8C9.5 7.44772 9.94772 7 10.5 7H31.8438C32.3961 7 32.8438 7.44772 32.8438 8V34.5161C32.8438 35.0684 32.3961 35.5161 31.8438 35.5161H10.5C9.94772 35.5161 9.5 35.0684 9.5 34.5161V8Z",
    fill: "url(#paint2_linear_11184_60508)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.9473,
    y: 11.2043,
    width: 14.4509,
    height: 3.29032,
    rx: 0.5,
    fill: "url(#paint3_linear_11184_60508)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.6147,
    cy: 18.5163,
    rx: 1.66742,
    ry: 1.64516,
    fill: "url(#paint4_linear_11184_60508)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.6147,
    cy: 24.0001,
    rx: 1.66742,
    ry: 1.64516,
    fill: "url(#paint5_linear_11184_60508)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.6147,
    cy: 29.6452,
    rx: 1.66742,
    ry: 1.64516,
    fill: "url(#paint6_linear_11184_60508)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.1713,
    cy: 18.5163,
    rx: 1.66742,
    ry: 1.64516,
    fill: "url(#paint7_linear_11184_60508)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.1713,
    cy: 24.0001,
    rx: 1.66742,
    ry: 1.64516,
    fill: "url(#paint8_linear_11184_60508)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.1713,
    cy: 29.6452,
    rx: 1.66742,
    ry: 1.64516,
    fill: "url(#paint9_linear_11184_60508)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.7299,
    cy: 18.5163,
    rx: 1.66742,
    ry: 1.64516,
    fill: "url(#paint10_linear_11184_60508)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0625,
    y: 22.355,
    width: 3.33483,
    height: 8.77419,
    rx: 0.5,
    fill: "url(#paint11_linear_11184_60508)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11184_60508",
    x1: 14.7441,
    y1: 27.7719,
    x2: 16.3298,
    y2: 31.1455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11184_60508",
    x1: 20.3008,
    y1: 27.7719,
    x2: 21.8865,
    y2: 31.1455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11184_60508",
    x1: 21.1719,
    y1: 7,
    x2: 21.1719,
    y2: 35.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11184_60508",
    x1: 17.4004,
    y1: 11.1376,
    x2: 17.8419,
    y2: 15.2086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11184_60508",
    x1: 14.7441,
    y1: 16.8044,
    x2: 16.3298,
    y2: 20.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11184_60508",
    x1: 14.7441,
    y1: 22.2883,
    x2: 16.3298,
    y2: 25.6618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11184_60508",
    x1: 14.7441,
    y1: 27.9333,
    x2: 16.3298,
    y2: 31.3069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11184_60508",
    x1: 20.3008,
    y1: 16.8044,
    x2: 21.8865,
    y2: 20.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11184_60508",
    x1: 20.3008,
    y1: 22.2883,
    x2: 21.8865,
    y2: 25.6618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11184_60508",
    x1: 20.3008,
    y1: 27.9333,
    x2: 21.8865,
    y2: 31.3069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11184_60508",
    x1: 25.8594,
    y1: 16.8044,
    x2: 27.4451,
    y2: 20.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11184_60508",
    x1: 25.8594,
    y1: 22.1771,
    x2: 31.2141,
    y2: 26.4492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/홀덤계산기.fb8fdf5180a720ac32f475868436f1e5.svg";
export { ForwardRef as ReactComponent };